<script setup lang="ts">
const props = withDefaults(defineProps<{
  w?: string
  mode?: string
  debug?: boolean,

  hairline?: string
  primary?: string
  subtitle?: string
  description?: string
  before?: string
  after?: string
}>(), {
  w: '',
  mode: '',
  debug: false, 

  hairline: '',
  primary: '',
  subtitle: '',
  description: '',
  before: '',
  after: '',
})


const $attrs = useAttrs()

const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})
</script>

<template>
  <div class="a-title" :class="[mode, { debug }]">
    <slot v-if="$slots.prewrap" name="prewrap" />
    <Wrap
      v-bind="filteredAttrs" :class="[mode, w, { debug }]"
    >
      <slot v-if="$slots.before" name="before" />

      <!-- Hairline -->
      <template v-if="$slots.hairline">
        <slot v-if="$slots.hairline" name="hairline" />
      </template>
      <template v-else-if="hairline">
        <div class="a-title-hairline glh-1" v-html="hairline" />
      </template>

      <!-- Primary title -->
      <template v-if="$slots.primary">
        <slot v-if="$slots.primary" name="primary" />
      </template>
      <template v-else-if="primary">
        <div class="a-title-primary" v-html="primary" />
      </template>
      <template v-if="$slots.subtitle">
        <slot v-if="$slots.subtitle" name="subtitle" />
      </template>
      <template v-else-if="subtitle">
        <div class="a-title-subtitle" v-html="subtitle" />
      </template>
      <template v-if="$slots.description">
        <slot v-if="$slots.description" name="description" />
      </template>
      <template v-else-if="description">
        <div class="a-title-description" v-html="description" />
      </template>

      <slot v-if="$slots.after" name="below" />

      <!-- Anything else-->
      <slot />
    </Wrap>
    <slot v-if="$slots.postwrap" name="postwrap" />
  </div>
</template>

<style lang="scss" scoped>
.a-title {
  // First level wrap
  :deep(>.m-wrap) {
    // body primary
    // color: var(--gray-900);
  }

  &.debug {
    background: rgba(255, 210, 210, 0.5);
    box-shadow: inset 0 0 0 1px red;
  }

  .a-title-hairline {
    color: var(--heading-hairline);
    font-size: fs(0);
    font-weight: 300;
    line-height: gr(1.25);
  }
  &.debug {
    .a-title-hairline {
      box-shadow: inset 0 0 0 1px red;
    }
  }

  .a-title-primary {
    color: var(--heading-primary);
    font-size: fs(5);
    font-weight: 400;
    line-height: gr(2);
    margin-bottom: gr(0.5);
  }
  &.debug {
    .a-title-primary {
      box-shadow: inset 0 0 0 1px blue;
    }
  }

  .a-title-subtitle {
    color: var(--heading-subtitle);
    font-size: fs(1);
    font-weight: 300;
    line-height: gr(1.5);
    margin-bottom: gr(1);
  }
  &.debug {
    .a-title-subtitle {
      box-shadow: inset 0 0 0 1px cyan;
    }
  }

  .a-title-description {
    color: var(--body-primary);
    font-size: fs(0);
    font-weight: 300;
    line-height: gr(1);
  }

  &.debug {
    .a-title-description {
      box-shadow: inset 0 0 0 1px green;
    }
  }
}
</style>
